import{jsxs as t,jsx as o}from"react/jsx-runtime";import{styled as e}from"styled-components";import{BACKGROUND_COLOR as r}from"./constants.mjs";const i=e.div`
  height: 41px;
  display: flex;
  position: relative;
`,d=e.div`
  display: flex;
`,l=e.div`
  border-top: 21px solid black;
  border-right: 0px solid black;
  border-bottom: 21px solid black;
  border-left: 10px solid transparent;
  width: 0px;
  height: 0px;
`,p=e.div`
  width: ${({width:t})=>t?t+1:71}px;
  height: 42px;
  text-align: center;
  background-color: black;
`,n=e.div`
  border-top: 21px solid transparent;
  border-left: 11px solid black;
  border-bottom: 21px solid transparent;
  width: 0px;
  height: 0px;
`,h=e.div`
  display: flex;
  position: absolute;
  left: 1px;
  top: 1px;
`,x=e.div`
  border-top: 20px solid white;
  border-right: 0px solid white;
  border-bottom: 20px solid white;
  border-left: 10px solid transparent;
  width: 0px;
  height: 0px;
`,s=e.div`
  width: ${({width:t})=>null!=t?t:70}px;
  height: 40px;
  text-align: center;
  background-color: white;
`,a=e.div`
  border-top: 20px solid transparent;
  border-left: 10px solid white;
  border-bottom: 20px solid transparent;
  width: 0px;
  height: 0px;
`,b=e.div`
  height: 40px;
  padding-top: 2px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;function c({index:e,activeStep:c,children:g,width:w}){const f=e<c?0:e===c?1:2;return t(i,{children:[t(d,{children:[o(l,{}),o(p,{width:w}),o(n,{})]}),t(h,{children:[o(x,{style:{borderTopColor:r[f],borderBottomColor:r[f]}}),o(s,{width:w,style:{backgroundColor:r[f]},children:o(b,{children:g})}),o(a,{style:{borderLeftColor:r[f],borderRightColor:r[f]}})]})]})}export{c as ArrowStepper};
